<template>
    <div class="" :class="$route.name === '舆情总揽'?'crumbsindex':'crumbs'">
        <div class="d-flex" style="justify-content: space-between;">
            <div class="planTitle">
                <span class="planname">{{$parent.isPlan.name}}</span>
                <a class="href fr" href="javascript:void(0);" @click.stop="delPlan($parent.isPlan.id);" title="删除方案"><i class="icons del-sm-icon"></i></a>
                <router-link v-if="userInfo.isAdmin" class="href fr" :to="{path:'/analysis/buildSolution',query:{'planId':$parent.isPlan.id}}" title="编辑当前方案"><i class="icons edit-icon3"></i></router-link>
                <a v-if="userInfo.isAdmin" class="href fr" href="javascript:void(0);" @click="openKeywordsMatching();" title="选择查看范围"><i class="icons select-icon"></i></a>
            </div>
            <ul class="navTop d-flex">
				<li v-for="(item,index) in $parent.company.config.leftMenus" :key="index">
                    <div v-if="item.checked">
                        <router-link class="db" :class="$route.meta.shuYu === item.key ? 'router-link-active' : ''" :to='"/analysis/"+item.key'><i class="icons fl" :class="item.icon"></i>{{item.value}}</router-link>
                    </div>
				</li>
            </ul>
        </div>
        <Dialog ref="keywordsMatch" title="选择关键词" :callback="keywordsMatching" type="normal" width="600">
			<div slot="mdBox" style="max-height:500px;overflow:auto">
				<div class="checkbox-group nolike clearfix" v-if="$parent.isPlan.keywordsMain&&$parent.isPlan.keywordsMain.length>0">
                    <p style="clear:both;height:30px;line-height:30px;width:500px;">主体词：</p>
					<label class="checkbox-box" v-for="(item,index) in $parent.isPlan.keywordsMain" :key="index">
						<label class="checkbox-warp fl" :class="keywordsMainSelect.indexOf(item) != -1 ? 'curr' : ''"><input name="" v-model="keywordsMainSelect" type="checkbox" :value="item" class="checkbox"> <i class="icons checkbox-icon"></i></label>
						<div class="hidden ac">{{item}}</div>
					</label>
				</div>
                <div class="checkbox-group nolike clearfix" v-if="$parent.isPlan.keywordGroup&&$parent.isPlan.keywordGroup.length>0">
                    <p style="clear:both;height:30px;line-height:30px;width:500px;margin-top:10px;">分析词：</p>
					<label class="checkbox-box" v-for="(item,index) in $parent.isPlan.keywordGroup" :key="index">
						<label class="checkbox-warp fl" :class="keywordSelect.indexOf(item) != -1 ? 'curr' : ''"><input name="" v-model="keywordSelect" type="checkbox" :value="item" class="checkbox"> <i class="icons checkbox-icon"></i></label>
						<div class="hidden ac">{{item}}</div>
					</label>
				</div>
			</div>
		</Dialog>
        <!-- 删除提示 -->
        <Dialog ref="delPlanModal" :callback="enterDelPlan" type="confirm">
            <div slot="mdBox">
                <p class="ac">是否删除此方案</p>
            </div>
        </Dialog>
    </div>
</template>
<script>
import Dialog from './dialog.vue';
import {mapState} from 'vuex';
export default {
    name: "",
    components:{Dialog},
    computed:{
        ...mapState({
            userInfo: state => state.user.userInfo,
        })
    },
    props: {},
    data() {
        return {
            keywordSelect:[],//方案关键词选择
            keywordsMainSelect:[],//方案主体词选择
            delId:''
        }
    },
    watch:{
        $route:{
            handler(to,from){
               console.log(to)

            },immediate:true 
        }
    },
    mounted() {
       
    },
    created() {
		
    },
    methods: {
        // 打开方案多个关键词组的匹配信息弹框
        openKeywordsMatching(){
            let that = this;
            if(this.$parent.isPlan.keywordsSelect){
                this.keywordSelect = [...this.$parent.isPlan.keywordsSelect];
            }
            if(this.$parent.isPlan.keywordsMainSelect){
                this.keywordsMainSelect = [...this.$parent.isPlan.keywordsMainSelect];
            }
            this.$refs.keywordsMatch.showMaskFun();
        },
        // 方案多个关键词组的匹配信息
        keywordsMatching () {
            let that = this;
            if(that.keywordSelect.length <= 0&&that.keywordsMainSelect.length <= 0){
                that.$utils.alertText('请选择关键词或主体词');
                return;
            }
            that.$parent.loadModal(true,'正在提交数据...');
            let datas = {
                sid:that.$parent.isPlan.id,
                keywordsSelect:that.keywordSelect,
                keywordsMainSelect:that.keywordsMainSelect
            }
            that.$api.post('monitor/scheme/keywords-select',{data:datas},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('设置成功');
                    location.reload();
                });           
            })
        },
        // 删除方案
        delPlan (id) {
            let that = this;
            that.delId = id;
            that.$refs.delPlanModal.showMaskFun();
        },
        // 确认删除
        enterDelPlan () {
            let that = this;
            that.$parent.loadModal(true,'正在提交数据...');
            that.$api.post('monitor/scheme/delete',{id:that.delId},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功');
                    if(that.$parent.isPlan.id == that.delId){//删除的方案是当前方案会刷新页面
                        location.reload();
                        return;
                    }
                    if(r.data.length === 0){//方案全部删除完
                        that.$parent.getCurrplan();
                        that.$refs.planModal.closeMask();
                        return;
                    }
                    that.planList = r.data;
                    that.searchPlan(that.searchQuery);
                    that.$refs.delPlanModal.closeMask();
                    that.$refs.planModal.showMaskFun();
                });           
            })
        },
	}
}
</script>
<style scoped>
.crumbs{
    margin:0 33px;
    background: #fff;
    margin-top:16px;
    position: relative;
    top:13px;
}
.crumbsindex{
    background: none;
    margin:0 33px;
    position: relative;
    top:13px;
}
.crumbs .navTop{padding:15px}
.crumbsindex .navTop{padding:15px;padding-left: 0;}
.crumbs .navTop li div{padding:0 10px;}
.crumbs .navTop a{color: #333;}
.crumbs .navTop li div .router-link-active{color: #0095eb;}
.crumbs .planTitle{padding:0 20px;}

.crumbsindex .navTop{padding:10px;padding-left: 0;}
.crumbsindex .navTop a{color: #fff;}
.crumbsindex .navTop li div{margin-left: 20px;}
.crumbsindex .navTop li div .router-link-active{color: #0095eb;}
.crumbsindex .planTitle{padding:0 20px;color: #fff;padding-left: 0;}
.href{margin-left: 10px;position: relative;top:20px;}
.planname{font-size: 24px;line-height:50px;}
</style>



// WEBPACK FOOTER //
// src/components/crumbs.vue